import { Button, ButtonRow } from '@ksyos/design-system';

interface IQuestionnaireFormButtonsProps {
    currentPage: number;
    goToNextPage: () => void;
    goToPreviousPage: () => void;
    nrOfPages: number;
    sendQuestionnaire: () => void;
}
export function QuestionnaireFormButtons(props: Readonly<IQuestionnaireFormButtonsProps>) {
    const { currentPage, goToNextPage, goToPreviousPage, nrOfPages, sendQuestionnaire } = props;

    return (
        <ButtonRow
            isStackedBelowSmall={true}
            justify="right"
        >
            {currentPage > 1 && (
                <Button
                    color="secondary"
                    onClick={goToPreviousPage}
                    sx={{ mr: [0, 'auto'] }}
                    variant="outline"
                >
                    Vorige
                </Button>
            )}

            {currentPage < nrOfPages && (
                <Button
                    color="secondary"
                    onClick={goToNextPage}
                    variant="solid"
                >
                    Volgende
                </Button>
            )}

            {currentPage === nrOfPages && (
                <Button
                    color="secondary"
                    onClick={sendQuestionnaire}
                    variant="solid"
                >
                    Verstuur
                </Button>
            )}
        </ButtonRow>
    );
}
